import React, { Component } from 'react';
import moment from 'moment';
import rome from 'rome';

export default class Modal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			mark: this.props.modal ? this.props.modal.mark : null,
			datetime: this.props.modal && this.props.modal.datetime ? this.props.modal.datetime : moment().format('YYYY-MM-DDTHH:mm'),
			comment: this.props.modal && this.props.modal.comment ? this.props.modal.comment : ''
		};

		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.datepickerRef = React.createRef();
	}

	componentDidMount() {
		this.datepicker = rome(this.datepickerRef.current, {
				'inputFormat': 'YYYY-MM-DDTHH:mm',
				'monthFormat': 'MMM YYYY',
				'dayFormat': 'D',
				'weekdayFormat': 'short'
			})
			.setValue(this.state.datetime)
			.on('data', value => this.handleInputChange({target: {name: 'datetime', value: value}}));
	}

	componentWillUnmount() {
		this.datepicker.destroy();
	}

	componentWillReceiveProps(nextProps) {
		this.setState(state => {
			state.mark = nextProps.modal ? nextProps.modal.mark : null;
			state.datetime = nextProps.modal && nextProps.modal.datetime ? nextProps.modal.datetime : moment().format('YYYY-MM-DDTHH:mm');
			state.comment = nextProps.modal && nextProps.modal.comment ? nextProps.modal.comment : '';

			this.datepicker.setValue(state.datetime);
			return state;
		});
	}

	handleInputChange(event) {
		this.setState({ [event.target.name]: event.target.value });
	}

	handleSubmit(event) {
		event.preventDefault();
		this.props.handleEditMark(
			this.state.mark ? 'EDIT' : 'NEW', {
				datetime: this.state.datetime,
				comment: this.state.comment,
				setId: this.props.selectedSet,
				tallyId: this.props.selectedTally,
				markId: this.state.mark
			}
		);
	}

	render() {
		return (
			<div className="MODAL">
				<form onSubmit={this.handleSubmit}>
					{ /* <input className="input" name="datetime" type="datetime-local" value={this.state.datetime} onChange={this.handleInputChange} placeholder="Date & Time" /> */ }

					<div className="datepicker" ref={this.datepickerRef}></div>
					<input className="input" name="comment" type="text" value={this.state.comment} onChange={this.handleInputChange} placeholder="Comment" />
					<button className="button alt-confirm" type="submit">{this.state.mark ? 'Save' : 'Add Mark'}</button>
					{this.state.mark && (
						<button className="button alt-delete" type="button" onClick={() => (
							this.props.handleEditMark('DELETE', { 
								setId: this.props.selectedSet,
								tallyId: this.props.selectedTally,
								markId: this.state.mark
							})
						)}>Delete</button>
					)}
					<label htmlFor="modal-toggle" className="button alt-cancel">Cancel</label>
				</form>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/modals/edit-mark.js